import {createCompositionRequest} from 'APIs/letrusAPI/composition';
import {fetchLearningPathStepRequest} from 'APIs/letrusAPI/learningPath';
import {LearningPathStep} from 'APIs/letrusAPI/learningPath/types';
import GeneralErrorModal from 'components/GeneralErrorModal';
import PageLoading from 'components/PageLoading';
import {useModals} from 'letrus-ui';
import {useNavigate} from 'react-router-dom';
import {useQueryParam} from 'utils/hooks';

function CreateComposition(): JSX.Element {
  const navigate = useNavigate();
  const queryParams = useQueryParam();
  const lpuiId = queryParams.get('trilha') ?? '';

  const modals = useModals(['error']);

  const createComposition = createCompositionRequest();
  const learningPathStep = fetchLearningPathStepRequest(lpuiId, {
    onSuccess: createNewComposition,
    onError: () => modals.error?.showModal(),
  });

  async function createNewComposition({
    activity_id,
    test,
    step_id,
    activity_type,
  }: LearningPathStep) {
    if (activity_type === 'write') {
      if (activity_id) {
        redirectToComposition(activity_id);
        return;
      }
      const createdComposition = await createComposition.trigger(
        {
          step_id,
          test_id: test?.id,
          instruction_id_id: test?.theme_id,
        },
        {onError: () => modals.error?.showModal()},
      );

      if (createdComposition) {
        redirectToComposition(createdComposition.id);
      }
    } else {
      learningPathStep.mutate();
    }
  }

  function redirectToComposition(compositionId: string | number) {
    navigate(
      {
        pathname: `/atividades/escrita/${compositionId}`,
        search: `trilha=${lpuiId}`,
      },
      {replace: true},
    );
  }

  return (
    <>
      <PageLoading />

      <GeneralErrorModal
        id="error"
        showIcon
        title="Oops!"
        description="Verifique sua conexão com a internet e tente novamente mais tarde"
        subTitle={
          createComposition.error
            ? 'Não foi possível criar uma redação'
            : 'Passo da trilha não encontrado'
        }
      />
    </>
  );
}

export default CreateComposition;
